import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    motivoEvaluacion: [],
  },

  getters: {
    getMotivoEvaluacion: (state) => state.motivoEvaluacion,
  },

  mutations: {
    SET_MOTIVO_EVALUACION(state, motivoEvaluacion) {
      state.motivoEvaluacion = motivoEvaluacion;
    },
  },

  actions: {
    async fetchMotivoEvaluacion({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catmotivoEvaluacion')
        .then((response) => {
          commit('SET_MOTIVO_EVALUACION', response.data.data);
        });
    },
  },
};
